import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { RichHtmlBlock } from '../types';
import styles from './RichHtml.module.css';
interface RichHtmlProps {
  block: RichHtmlBlock;
  blockId: string;
}

/**
 * Escape hatch for truly bespoke fragments. The migrator MUST justify each use
 * via `block.reason`. Renders with `dangerouslySetInnerHTML` — the converter is
 * responsible for any sanitization upstream.
 */
export function RichHtml(t0) {
  const $ = _c(6);
  const {
    block,
    blockId
  } = t0;
  let t1;
  if ($[0] !== block.html) {
    t1 = {
      __html: block.html
    };
    $[0] = block.html;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== block.reason || $[3] !== blockId || $[4] !== t1) {
    t2 = <div className={styles.wrapper} data-cms-block-id={blockId} data-cms-field="richHtml" data-richhtml-reason={block.reason} dangerouslySetInnerHTML={t1} />;
    $[2] = block.reason;
    $[3] = blockId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}